import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button } from "../../../../shared/Button/Button";
import { Select } from "../../../../shared/Select/Select";
import { updateTimeTracking } from "../../../../Actions/BusinessInsights/businessInsightActions";
import { uiNotification } from "../../../../services/UINotificationService";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import styles from "./TrackedAs.module.scss";

const TrackedAs = ({ detail, availableTrackAs, updateTimeTracking }) => {
  const [editMode, setEditMode] = useState(false);
  const selectOptions = Object.values(availableTrackAs || {}).map((item) => ({
    label: item.display_name,
    value: item.id,
  }));
  const [selectedOption, setSelectedOption] = useState(
    selectOptions?.find((option) => option.label === detail.tracked_as),
  );
  const [isLoading, setIsLoading] = useState(false);

  return !editMode ? (
    <div className="flex items-center gap-8">
      {detail.tracked_as}{" "}
      <Button
        size="tiny"
        variant="text"
        onClick={() => setEditMode(true)}
        className={styles.editButton}
      >
        <i className="fa fa-pencil-alt"></i>
      </Button>
    </div>
  ) : isLoading ? (
    <CircularProgress size="small" />
  ) : (
    <div className="flex-col gap-8">
      <Select
        size="small"
        options={selectOptions}
        value={selectedOption}
        onChange={(option) => {
          setIsLoading(true);
          setSelectedOption(option);
          updateTimeTracking(detail.id, { tracked_as: option.value })
            .then(() => {
              uiNotification.success("Updated Successfully");
            })
            .catch(() => {
              uiNotification.error("Something went wrong. Please try again.");
            })
            .finally(() => {
              setEditMode(false);
              setIsLoading(false);
            });
        }}
      />
      <Button
        size="tiny"
        className={styles.cancelButton}
        onClick={() => setEditMode(false)}
      >
        Cancel
      </Button>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateTimeTracking,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(TrackedAs);
